<template>
  <div class="page__shop a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <el-row :gutter="10">
        <el-col :sm="6"><strong style="font-size: 16px">{{ $t('shop.list') }}</strong></el-col>
        <el-col :sm="18" class="text-right">
          <el-input size="mini" :placeholder="$t('input.placeholder') + '...'" style="max-width: 250px;"
                    prefix-icon="el-icon-search" v-model="input_keyword" clearable/>
          &nbsp;&nbsp;
          <el-button v-if="$route.query.login_code" size="mini" icon="el-icon-info" type="primary"
                     @click="m__show_upload_file_dialog">
            {{ $t('shop.add_by_code') }}
          </el-button>
          <el-button size="mini" icon="el-icon-plus" type="primary" @click="m__show_login_shopee">
            {{ $t('shop.add') }}
          </el-button>
        </el-col>
      </el-row>

      <br>
      <div>
        <div style="font-size: 14px; line-height: 30px; font-weight: 700" class="text-danger">
          - {{ $t('shop.guide.1') }}
          <a href="javascript:void(0)" style="font-size: 13px;" @click="show_dialog.add_shop = true">
            {{ $t('base.here') }}.
          </a>
          <br>

          - {{ $t('shop.guide.2') }}
          <a href="javascript:void(0)" style="font-size: 13px;" @click="show_dialog.rename_shop = true">
            {{ $t('base.here') }}.
          </a>
          <br>

          - {{ $t('shop.guide.3') }}
          <a href="javascript:void(0)" style="font-size: 13px;" @click="show_dialog.add_shop_error = true">
            {{ $t('base.here') }}.
          </a>
          <br>

          - {{ $t('shop.guide.4') }}
        </div>
      </div>

      <div style="margin-top:20px;">
        <table id="shop-table" class="table table-hover" style="font-size:12px;">
          <thead>
          <tr>
            <th style="width: 50px">#</th>
            <th>Logo</th>
            <th>{{ $t('base.username') }}</th>
            <th v-if="enable_global"></th>
            <th>{{ $t('base.default') }}</th>
            <th>{{ $t('base.created_at') }}</th>
            <th>{{ $t('base.proxy_status') }}</th>
            <th>{{ $t('base.link_shop') }}</th>
            <th style="width: 250px">{{ $t('base.action') }}</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(item, index) in c__shopee_shop_filer_list">
            <tr id="main-tr">
              <td>{{ index + 1 }}</td>
              <td>
                <img style="width: 32px; height:32px;" v-if="item.image.length>0" :src="item.image"
                     alt="shopee login">
              </td>
              <td>
                <div
                  :style="`${(typeof item.user_id==='undefined' || item.user_id.length===0) && item.channel==='shopee_marketing'?'color:red;':''}`">
                  {{ item.username }}
                </div>
                <div style="font-size:10px; color:gray;">
                  ID: <span>{{ item.user_id || item.shop_id }}</span>
                </div>
                <div v-if="show_x_id_fixed_list.includes($store.state.userInfo.username)"
                     style="font-size:10px; color:gray;">
                  XID: <span>{{ item._id }}</span>
                </div>
                <div v-if="show_x_id_fixed_list.includes($store.state.userInfo.username)"
                     style="font-size:10px; color:gray;">
                  PXD: <span>{{ item.extra_data.system_proxy }}</span>
                </div>
              </td>
              <td v-if="enable_global">
                <div>
                  <template
                    v-if="item.extra_data && item.extra_data.country && global_shops.find(i => i.country === item.extra_data.country)">
                    <img style="width: 35px; height: 23px; object-fit: contain"
                         :src="global_shops.find(i => i.country === item.extra_data.country).flag" alt="">
                  </template>
                </div>
              </td>
              <td>
                <el-switch sizi="mini" v-model="item.extra_data.default"
                           @change="m__change_default(item, $event)"></el-switch>
              </td>
              <td>{{ item.created_time | timeFormat }}</td>
              <td>
                <template v-if="item.extra_data.proxy">
                  <strong v-if="item.proxy_ok" class="text-success">
                    {{ `${item.extra_data.proxy.proxy_server}:${item.extra_data.proxy.proxy_port}` }}
                    ({{ $t('base.good') }})
                  </strong>
                  <strong v-else class="text-danger">
                    {{ `${item.extra_data.proxy.proxy_server}:${item.extra_data.proxy.proxy_port}` }}
                    ({{ $t('base.error') }})
                  </strong>
                </template>
                <template v-else>
                  <strong style="color: #999">
                    {{ $t('shop.using_system_proxy') }}
                  </strong>
                </template>
              </td>
              <td>
                <template v-if="item.extra_data.linked">
                  <el-tooltip content="Click để liên kết lại tài khoản" placement="top">
                    <el-button size="mini" type="text" @click="m__get_login">
                      <strong class="text-success">{{ $t('base.linked_shop') }}</strong>
                    </el-button>
                  </el-tooltip>
                </template>
                <template v-else>
                  <el-button type="text" size="mini" icon="el-icon-link" @click="m__get_login">
                    <strong class="text-primary">{{ $t('base.link_shop') }}</strong>
                  </el-button>
                </template>
              </td>
              <td>
                <template v-if="connect_platform_fixed_list.includes($store.state.userInfo.username)">
                  <el-tooltip :content="$t('base.connect_platform')" placement="top">
                    <el-button size="mini" icon="el-icon-connection" type="success"
                               :loading="item.loading" @click="m__open_connect_platform_dialog(item)"/>
                  </el-tooltip>
                  &nbsp;
                </template>
                <el-tooltip :content="$t('base.config_proxy')" placement="top">
                  <el-button size="mini" icon="el-icon-cloudy" type="success" @click="m__show_config_proxy(item)"
                             :loading="item.loading"/>
                </el-tooltip>
                &nbsp;
                <el-tooltip :content="$t('shop.re_login')" placement="top">
                  <el-button size="mini" icon="el-icon-refresh" type="success" @click="m__re_login(item)"
                             :loading="item.loading"/>
                </el-tooltip>
                &nbsp;
                <el-tooltip :content="$t('shop.delete')" placement="top">
                  <el-button size="mini" icon="el-icon-delete" type="danger" :loading="loading.delete_shop"
                             @click="m_delete_shopee_connect(item)"/>
                </el-tooltip>
              </td>
            </tr>
            <tr>
              <td colspan="14"
                  style="background-color: whitesmoke; border-radius: 10px; font-size: 11px; padding-left: 12px !important; padding-bottom: 12px !important;"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>

      <div style="margin-top: 80px" v-if="connect_platform_fixed_list.includes($store.state.userInfo.username)">
        <el-row :gutter="10">
          <el-col :sm="6"><strong style="font-size: 16px">{{ $t('shop.google.list') }}</strong></el-col>
          <el-col :sm="18" class="text-right">
            <el-button size="mini" icon="el-icon-plus" type="primary" @click="m__show_connect_google_sheet_dialog">
              {{ $t('shop.google.connect') }}
            </el-button>
          </el-col>
        </el-row>

        <el-table style="margin-top: 20px" :data="open_platform_google_account_list">
          <el-table-column type="index" label="#" width="40px"></el-table-column>
          <el-table-column :label="$t('shop.google.account_id')" prop="account_info.id"></el-table-column>
          <el-table-column :label="$t('shop.google.account_name')" prop="account_info.name"></el-table-column>
          <el-table-column :label="$t('base.status')" prop="account_info.name">
            <template slot-scope="scope">
              <strong v-if="scope.row.status === 'activate'" class="text-success">
                {{ $t('base.active') }}
              </strong>
              <strong v-if="scope.row.status === 'deactivate'" class="text-danger">
                {{ $t('base.deactivate') }}
              </strong>
            </template>
          </el-table-column>
          <!--          <el-table-column :label="$t('base.optional')" width="120px">
                      <template slot-scope="scope">
                        <el-tooltip :content="$t('shop.google.delete')" placement="top">
                          <el-button size="mini" icon="el-icon-delete" type="danger"/>
                        </el-tooltip>
                      </template>
                    </el-table-column>-->
        </el-table>
      </div>
    </div>

    <el-dialog :visible.sync="shopee_login" width="400px" :close-on-click-modal="false" custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <div class="text-center">
          <img :src="logo_channel('shopee_marketing')" alt="logo"
               style="width: 60px; height:60px; border-radius: 50vh;">
        </div>
        <form @submit.prevent="m__login_shopee_shop">
          <p class="text-title">{{ $t('base.username') }}</p>
          <el-input size="mini" :placeholder="$t('input.username')"
                    v-model="dialog_add_shop.form.username"/>

          <p class="text-title">{{ $t('base.password') }}</p>
          <el-input size="mini" type="password"
                    :placeholder="`${$t('input.password_for')} ${this.dialog_add_shop.form.username}...`"
                    v-model="dialog_add_shop.form.password" show-password/>

          <template v-if="enable_global">
            <p class="text-title">{{ $t('base.country') }}</p>
            <el-select v-model="dialog_add_shop.form.country" value="" size="mini" class="full-w">
              <el-option v-for="item of global_shops" :key="item.country" :value="item.country" :label="item.name">
                <div>
                  <span style="background-color: #feece1; color: #ff831d; padding: 2px 2px 2px 4px; width: 27px">
                    {{ item.code.toUpperCase() }}
                  </span>
                  &nbsp;
                  &nbsp;
                  <span>{{ item.name }}</span>
                </div>
              </el-option>
            </el-select>
          </template>

          <template v-if="$route.query.login_code">
            <p class="text-title">{{ $t('base.login_code') }} 1</p>
            <el-input size="small" v-model="dialog_add_shop.form.cookie"/>
          </template>

          <template v-if="dialog_add_shop.otp_require">
            <p class="text-title">{{ $t('base.otp_code') }}</p>
            <el-input size="small" :placeholder="`${$t('input.otp')} ${this.dialog_add_shop.form.username}...`"
                      v-model="dialog_add_shop.form.otp_code"/>
          </template>

          <br>
          <br>

          <strong v-if="is_verify_otp" class="text-danger">
            {{ verify_otp_message }}
          </strong>
          <strong v-if="is_otp_error" class="text-danger">
            {{ $t('shop.cannot_verify_otp') }}
          </strong>

          <div style="padding-top:20px;" class="text-right">
            <el-button size="mini" icon="el-icon-close" type="text" @click="shopee_login=false">
              {{ $t('base.close') }}
            </el-button>
            <el-button size="mini" icon="el-icon-check" type="primary" @submit.prevent="m__login_shopee_shop()"
                       native-type="submit" :loading="dialog_add_shop.loading">
              {{ $t('shop.add') }}
            </el-button>
          </div>
        </form>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="config_proxy" width="400px" :close-on-click-modal="false" custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <strong class="strong-title">{{ $t('base.config_proxy') }}</strong>

        <br>
        <p class="text-title" style="">Proxy Type</p>
        <el-checkbox-group v-model="form_proxy.proxy_type">
          <el-checkbox label="HTTP"
                       :disabled="form_proxy.proxy_type.length === 1 && form_proxy.proxy_type[0]  !== 'HTTPS'"></el-checkbox>
          <el-checkbox label="HTTPS"
                       :disabled="form_proxy.proxy_type.length === 1 && form_proxy.proxy_type[0]  !== 'HTTP'"></el-checkbox>
        </el-checkbox-group>

        <p class="text-title" style="">Proxy Server</p>
        <el-input size="mini" placeholder="127.0.0.1" v-model="form_proxy.proxy_server"></el-input>

        <p class="text-title" style="">Proxy Port</p>
        <el-input type="number" size="mini" placeholder="8080" v-model="form_proxy.proxy_port"></el-input>

        <br>
        <p class="text-title" style="">Proxy Auth &nbsp;
          <el-switch
            v-model="form_proxy.proxy_auth"
            active-color="#13ce66"
            inactive-color="#b7b7b7">
          </el-switch>
        </p>


        <p class="text-title" style="">Username</p>
        <el-input type="password" size="mini" placeholder="Username" :disabled="!this.form_proxy.proxy_auth"
                  v-model="form_proxy.proxy_username" show-password></el-input>

        <p class="text-title" style="">Password</p>
        <el-input type="password" size="mini" placeholder="Password" :disabled="!this.form_proxy.proxy_auth"
                  v-model="form_proxy.proxy_password" show-password></el-input>

        <div class="text-right" style="margin-top: 15px">
          <el-button v-if="form_proxy.proxy_server" size="mini" type="danger" :loading="this.loading.test_proxy"
                     @click="m__delete_proxy">
            {{ $t('base.delete') }} Proxy
          </el-button>
          <el-button size="mini" type="info" :loading="this.loading.test_proxy" @click="m__test_proxy">
            Test Proxy
          </el-button>
          <el-button size="mini" type="primary" :loading="this.loading.save_config_proxy" @click="m__save_config_proxy">
            {{ $t('base.save_config') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.import_file" width="600px" :close-on-click-modal="false"
               custom-class="no-body">
      <div style="padding:30px; " slot="title">
        <div style="font-size: 15px; line-height: 30px; font-weight: 700" class="text-danger">
          - {{ $t('shop.extension_link') }}
          <a href="https://chrome.google.com/webstore/detail/j2team-cookies/okpidcojinmlaakglciglbpcpajaibco"
             style="font-size: 15px;" target="_blank">
            {{ $t('base.here') }}.
          </a>
          <br>

          - {{ $t('shop.extension_video') }}
          <a href="https://www.youtube.com/watch?v=YEWuOgCtt5w&ab_channel=ATOSAMarketingAutomationShopee"
             style="font-size: 15px;" target="_blank">
            {{ $t('base.here') }}.
          </a>
          <br>
        </div>

        <div style="margin-top: 20px; display: flex; gap: 10px">
          <el-select v-if="enable_global" v-model="dialog_add_shop.form.country" value="" size="small"
                     style="width: 220px">
            <el-option v-for="item of global_shops" :key="item.country" :value="item.country" :label="item.name">
              <div>
                <span style="background-color: #feece1; color: #ff831d; padding: 2px 2px 2px 4px;">
                  {{ item.code.toUpperCase() }}
                </span>
                &nbsp;
                &nbsp;
                <span>{{ item.name }}</span>
              </div>
            </el-option>
          </el-select>
          <el-button size="small" type="primary" icon="el-icon-upload" style="width: 130px"
                     :loading="loading.import_file" @click="m__upload_file">
            <strong>Upload file</strong>
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- TODO: translate later   -->

    <el-dialog :visible.sync="show_dialog.add_shop" width="700px" :close-on-click-modal="false" custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <div style="display: inline-block">
          <div>
            <strong style="font-size: 18px">Hướng dẫn thêm cửa hàng trên Atosa</strong>
          </div>

          <div style="margin-top: 20px">
            <div class="add-shop-guide">
              <strong>Bước 1:</strong> Quý khách vui lòng mở 1 trình duyệt ẩn danh hoặc 1 phần mềm mà quý khách chưa
              từng sử dụng trước đây sau đó thử đăng nhập để xác định xem liên kết Shopee được gửi về Email hay Tin nhắn
              SMS, cũng như xác định được địa chỉ Email hoặc SĐT sẽ nhận được liên kết.
              <br>
              <br>
              <strong>Bước 2: </strong> Sau khi đã đăng nhập thử thành công trên trình duyệt, quý khách truy cập vào mục
              Cửa hàng Shopee trên Atosa, chọn Thêm cửa hàng. Sau
              đó nhập <strong>tài khoản</strong> và <strong>mật khẩu</strong> của cửa hàng và chờ xác nhận liên kết thêm
              một lần nữa.
              <br>
              <br>
              <strong>Bước 3: </strong> Để sử dụng thêm các tính năng trên Atosa, tại phần danh sách cửa hàng quý khách
              vui lòng chọn <strong>Liên kết tài khoản</strong>, sau đó nhập lại thông tin tài khoản để liên kết.
              <br>
              <br>
              <strong>Lưu ý: </strong> Nếu không thể thêm cửa hàng sau 2 lần gửi yêu cầu, quý khách vui lòng liên hệ với
              bộ phận CSKH để được hỗ trợ thêm cửa hàng một cách nhanh nhất.
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.rename_shop" width="700px" :close-on-click-modal="false"
               custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <div style="display: inline-block">
          <div>
            <strong style="font-size: 18px">Hướng dẫn đổi tên cửa hàng trên Atosa</strong>
          </div>

          <div style="margin-top: 20px">
            <div class="add-shop-guide">
              <strong>Bước 1:</strong> Quý khách vui lòng liên hệ với bộ phận CSKH.
              <br>
              <br>
              <strong>Bước 2: </strong> Quý khách cung cấp thông tin về tên cũ và tên mới của cửa hàng và đợi trong ít
              phút.
              <br>
              <br>
              <strong>Bước 3: </strong> Sau khi hệ thống Atosa cập nhật lại tên cửa hàng thành công bộ phận CSKH sẽ báo
              lại cho quý khách, quý khách vui lòng đăng nhập lại cửa hàng.
              <br>
              <br>
              <strong>Lưu ý: </strong> Đổi tên cửa hàng sẽ không ảnh hưởng tới cấu hình cài đặt trước đó.
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.add_shop_error" width="700px" :close-on-click-modal="false"
               custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <div style="display: inline-block">
          <div>
            <strong style="font-size: 18px">Hướng dẫn xử lý lỗi hay gặp khi đăng nhập cửa hàng</strong>
          </div>

          <div style="margin-top: 20px">
            <div class="add-shop-guide">
              <strong class="text-danger">- Lỗi Captcha khi Đổi tên hoặc Đổi mật khẩu của cửa hàng:</strong>
              <div style="height: 10px"></div>
              <strong>Bước 1:</strong> Quý khách hãy truy cập vào <a href="https://shopee.com" target="_blank"><strong>trang
              người mua</strong></a>, sau đó quý khách hãy đăng xuất tài khoản hiện tại (nếu có).
              <br>
              <br>
              <strong>Bước 2: </strong> Quý khách truy cập <a href="https://shopee.com/buyer/login"
                                                              target="_blank"><strong>trang đăng nhập</strong></a>,
              sau đó nhập <strong>tài khoản</strong> và <strong>mật khẩu</strong> của cửa hàng và đăng nhập. Quý khách
              vui lòng sử dụng <strong>username</strong> của cửa hàng thay vì SĐT hoặc Email.
              <br>
              <br>
              <strong>Bước 3: </strong> Kéo để xác nhận Captcha của Shopee, sau đó đăng nhập lại cửa hàng trên Atosa.
              <br>
              <br>
              <strong>Lưu ý: </strong> Bắt buộc phải sử dụng <strong>username</strong> của cửa hàng để xử lý lỗi
              Captcha.
              <br>
              <br>
              <br>
              <br>
              <strong class="text-danger">- Lỗi khi thêm cửa hàng trên Atosa:</strong>
              <div style="height: 10px"></div>
              Nếu như quý khách đã xác nhận thành công liên kết của Shopee mà vẫn không thể đăng nhập, quý khách vui
              lòng thông báo với bộ phận CSKH để được hỗ trợ sớm nhất.
              <br>
              <br>
              <br>
              <br>
              <strong class="text-danger">- Lỗi khi xóa nhầm cửa hàng trên Atosa:</strong>
              <div style="height: 10px"></div>
              Quý khách vui lòng thông báo với bộ phận CSKH để được khôi phục lại cửa hàng hoặc khôi phục lại các cấu
              hình cài đặt trước đó. Thời gian xử lý từ 1-2 ngày.
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="setup_shop" width="400px" :close-on-click-modal="false" custom-class="no-body">
      <div style="padding:10px; " slot="title">
        <div style="display: inline-block">
          <strong class="strong-label">Cấu hình shop: </strong>
        </div>
        <div style="display: inline-block">
          <strong class="strong-label text-danger">&nbsp;&nbsp;{{ selected_shop.username }}</strong>
        </div>

        <div style="height: 20px"></div>

        <el-radio v-model="use_ip" :label="0">
          <span style="font-size: 13px">Sử dụng proxy của hệ thống hoặc cá nhân</span>
        </el-radio>
        <div style="height: 20px"></div>
        <el-radio v-model="use_ip" :label="1">
          <span style="font-size: 13px">Sử dụng IP của thiết bị</span>
        </el-radio>

        <div style="margin-top: 20px" class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__setup_shop"
                     :loading="loading.setup_shop">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.connect_platform" width="600px" :close-on-click-modal="false"
               custom-class="no-body">
      <div style="padding:30px; " slot="title">
        <el-tabs v-model="platform_tab" class="small-tab-items">
          <el-tab-pane label="Đồng bộ dữ liệu hàng ngày" name="daily">
            <div>
              <div style="margin-top: 20px;">
                <el-row>
                  <el-col :sm="11">
                    <el-select size="mini" value="atosa" class="full-w" v-model="form_sync_data.source">
                      <el-option value="atosa" label="Lưu dữ liệu trên hệ thống Atosa"></el-option>
                      <!--                      <el-option value="lark" label="Lưu dữ liệu trên Lark Excel"></el-option>-->
                      <el-option value="sheet" label="Lưu dữ liệu trên Google Sheet"></el-option>
                    </el-select>

                    <div v-if="form_sync_data.source === 'sheet'" style="margin-top: 20px">
                      <strong class="strong-label">Tài khoản kết nối</strong>
                      <el-select size="mini" value="" class="full-w" v-model="form_sync_data.google_account_id">
                        <el-option v-for="i in open_platform_google_account_list"
                                   :key="i.account_id"
                                   :value="i.account_id"
                                   :label="`${i.account_id} - ${i.account_info.name}`"></el-option>
                      </el-select>

                      <br>
                      <br>

                      <strong class="strong-label">Link Google sheet</strong>
                      <el-input size="mini" v-model="form_sync_data.google_sheet_link"></el-input>

                      <br>
                      <br>

                      <strong class="strong-label">Chọn sheet</strong>
                      <el-select size="mini" value="" class="full-w" v-model="form_sync_data.google_sheet_sheet_id">
                        <el-option v-for="item in form_sync_data.google_sheet_sheet_list" :key="item.title"
                                   :value="item.title" :label="item.title"></el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :sm="13" style="padding-left: 10px">
                    <el-input v-if="false" size="mini"></el-input>
                  </el-col>
                </el-row>
              </div>
              <div style="margin-top: 40px;">
                <el-row style="margin-bottom: 40px">
                  <el-col :sm="18">
                    <div style="display: flex; gap: 10px; align-items: center">
                      <el-switch v-model="form_sync_data.sync_campaign"></el-switch>
                      <span style="font-size: 14px">Đồng bộ dữ liệu chỉ số quảng cáo</span>
                    </div>
                  </el-col>
                  <el-col :sm="6" class="text-right">
                    <el-button type="primary" size="mini" :loading="loading.export_campaigns"
                               @click="m__sync_data_export_campaigns">
                      Tải dữ liệu
                    </el-button>
                  </el-col>
                </el-row>
              </div>

              <el-row style="margin-top: 40px; border-top: 1px solid #dcdcdc; padding-top: 20px">
                <el-col :sm="12">
                  <strong class="text-danger">
                    - Hệ thống sẽ bắt đầu đồng bộ dữ liệu từ 2h hàng ngày.
                  </strong>
                </el-col>
                <el-col :sm="12" class="text-right">
                  <el-button type="primary" size="mini" icon="el-icon-check" :loading="loading.sync_data"
                             @click="m__confirm_update_sync_data">
                    {{ $t('base.save_config') }}
                  </el-button>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="show_dialog.connect_google_sheet" width="600px" :close-on-click-modal="false"
               custom-class="no-body">
      <div style="padding:15px 20px;" slot="title">
        <div style="display: flex; gap: 10px">
          <div>
            <img src="/static/img/icon-google-sheet.svg" alt="" style="width: 30px; height: 30px">
          </div>
          <div>
            <strong style="font-size: 18px">Google Sheets</strong>
          </div>
        </div>

        <div style="line-height: 35px; font-size: 14px; margin-top: 30px">
          Lưu dữ liệu quảng cáo của shop vào Google Sheets.
          <br>
          Vui lòng bấm "Tiếp tục" để đăng nhập vào tài khoản Google.
        </div>

        <div style="display: flex; margin-top: 30px">
          <div style="flex: 2; padding-top: 5px">
            <i class="el-icon-question" style="font-size: 14px"></i>
            <a
              href="https://www.youtube.com/watch?v=SJOZ9BkZRCs&feature=youtu.be&ab_channel=ATOSAMarketingAutomationShopee"
              target="_blank" style="font-size: 13px; color: #000">
              Hướng dẫn liên kết tài khoản
              <strong class="text-primary" style="font-size: 13px">Google Sheets</strong>
            </a>
          </div>
          <div style="flex: 1" class="text-right">
            <el-button size="mini" @click="show_dialog.connect_google_sheet = false">Hủy bỏ</el-button>
            <el-button type="primary" size="mini" @click="m__get_google_auth_url">Tiếp tục</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- TODO: end translate later   -->

    <input type="file" @change="m__import_cookie_file" id="input_control_detail" style="display: none;">
  </div>
</template>

<script>
import {omit as _omit} from 'lodash'
import {SPUserV4} from '../../addon/SPUserV4'
import {global_shops} from "../../addon/global_config"
import {connect_platform_fixed_list, show_x_id_fixed_list} from '../../addon/fixed_list'

export default {
  name: 'page__shop',

  data() {
    return {
      shopee_login: false,
      config_proxy: false,
      rename: false,
      new_username: '',
      input_keyword: '',
      selected_shop: {},
      shopee_shop: {
        loading: false,
        list: []
      },
      dialog_add_shop: {
        show: false,
        loading: false,
        otp_require: false,
        form: {
          username: '',
          password: '',
          pin_password: '',
          otp_code: '',
          cookie: '',
          x_sp_dfp: '',
          country: 'vn'
        }
      },
      form_proxy: {
        proxy_type: ['HTTP', 'HTTPS'],
        proxy_server: '',
        proxy_port: null,
        proxy_auth: false,
        proxy_username: '',
        proxy_password: ''
      },
      loading: {
        save_config_proxy: false,
        test_proxy: false,
        delete_shop: false,
        rename: false,
        recovery_config: false,
        setup_shop: false,
        import_file: false,
        connect_platform: false,
        sync_data: false,
        export_campaigns: false
      },
      show_dialog: {
        add_shop: false,
        rename_shop: false,
        add_shop_error: false,
        recovery_config: false,
        import_file: false,
        connect_platform: false,
        connect_google_sheet: false
      },
      is_deleted: false,
      is_verify_otp: false,
      is_otp_error: false,
      verify_second: 160,
      verify_otp_message: '',

      form_recovery_config: {
        shop_id: null,
        types: []
      },

      use_ip: 0,
      setup_shop: false,

      import_username: null,
      import_cookie: null,

      platform_tab: 'daily',
      form_lark_platform: {
        shop_id: null,
        webhook_url: ''
      },
      form_sync_data: {
        source: 'atosa',
        sync_shop: false,
        sync_product: false,
        sync_campaign: false,
        google_account_id: null,
        google_sheet_link: '',
        google_sheet_sheet_id: null,
        google_sheet_sheet_list: []
      },
      open_platform_google_account_list: [],
      connect_platform_fixed_list,
      show_x_id_fixed_list,
      global_shops: global_shops,
    }
  },

  async beforeMount() {
    try {
      const {
        code,
        platform,
        shop_id
      } = this.$route.query
      if (code && platform && shop_id) {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/ads_platform/verify_login_code', {
          shop_id: shop_id,
          code: code,
        }, this.cf())

        if (response && response.body && response.body.data && response.body.data.access_token) {
          this.ntf_s(this.$t('shop.connect_ads_platform_success'))

          const query = {...this.$route.query};
          delete query.code;
          delete query.platform;
          delete query.shop_id;
          this.$router.replace({query}).catch(console.error);
        }
      }
    } catch (e) {
      console.error(e)
    }

    await this.m__get_current_pack()
    await this.m__get_shopee_shop()

    await this.m__get_platform_google_account()
    await this.m__update_platform_google_account()
  },

  async beforeDestroy() {
    this.is_deleted = true
  },

  watch: {
    // 'form_sync_data.google_account_id': function () {
    //   setTimeout(() => this.m__get_google_sheet_sheet_list(), 1000)
    // },

    'form_sync_data.google_sheet_link': function () {
      setTimeout(() => this.m__get_google_sheet_sheet_list(), 200)
    }
  },

  computed: {
    c__shopee_shop_filer_list() {
      let result = this.shopee_shop.list

      return result.filter(item => this.remove_unicode(JSON.stringify(item)).match(this.input_keyword))
    }
  },

  methods: {
    m__show_connect_google_sheet_dialog() {
      this.show_dialog.connect_google_sheet = true
    },

    async m__get_google_sheet_sheet_list(is_ntf = false) {
      if (!this.form_sync_data.google_account_id || !this.form_sync_data.google_sheet_link) {
        this.form_sync_data.google_sheet_sheet_id = null
        this.form_sync_data.google_sheet_sheet_list = []
        return
      }

      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/get_google_sheet_spread_sheet', {
          google_account_id: this.form_sync_data.google_account_id,
          google_sheet_link: this.form_sync_data.google_sheet_link
        }, this.cf())
        if (response.body && response.body.data) {
          this.form_sync_data.google_sheet_sheet_list = response.body.data.sheets.map(i => i.properties)
        }
      } catch (e) {
        console.error(e)
        if (is_ntf) this.ntf_w(e)
      }
    },

    async m__update_platform_google_account() {
      const {
        code,
        scope
      } = this.$route.query
      if (code && scope) {
        try {
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/verify_google_auth_code', {code}, this.cf())
          await this.m__get_platform_google_account()
          this.$router.replace({'query': null})
          this.ntf_s(this.$t('shop.add_success'))
        } catch (e) {
          console.error(e)
          this.ntf_w(e)
        }
      }
    },

    async m__get_platform_google_account() {
      const response = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/open_platform/get_google_account', this.cf())
      for (const item of response.body.data) {
        item.status = ''
        this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/check_google_account', {google_account_id: item.account_id}, this.cf())
          .then(response => {
            if (response.body.data.active) {
              item.status = 'activate'
            } else {
              item.status = 'deactivate'
            }
          })
          .catch(console.error)
      }
      this.open_platform_google_account_list = response.body.data
    },

    async m__get_google_auth_url() {
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/get_google_auth_url', {}, this.cf())
      window.location.href = response.body.data.auth_url
    },

    async m__sync_data_export_campaigns() {
      this.loading.export_campaigns = true
      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/sync_data/export_campaigns', {shop__id: this.selected_shop._id}, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `shop_data-${this.selected_shop.username}.xlsx`)
      document.body.appendChild(link)
      link.click()

      this.loading.export_campaigns = false
    },

    async m__confirm_update_sync_data() {
      this.loading.sync_data = true
      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/sync_data/config', {
          ...this.form_sync_data,
          test_google_sheet: ['ads.atosa14@gmail.com'].includes(this.$store.state.userInfo.username)
        }, this.cf())
        this.selected_shop.sync_data = this.form_sync_data
        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.connect_platform = false
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.loading.sync_data = false
      }
    },

    m__open_connect_platform_dialog(data) {
      this.selected_shop = data
      this.form_lark_platform.shop_id = data.shop_id

      if (data.connect_platform) {
        this.form_lark_platform.webhook_url = data.connect_platform.webhook_url
      } else {
        this.form_lark_platform.webhook_url = ''
      }

      if (data.sync_data) {
        Object.assign(this.form_sync_data, data.sync_data)
        this.form_sync_data.shop__id = data._id
      } else {
        Object.assign(this.form_sync_data, {
          source: 'atosa',
          sync_shop: false,
          sync_product: false,
          sync_campaign: false,
          shop__id: data._id
        })
      }

      this.show_dialog.connect_platform = true
    },

    async m__check_lark_webhook() {
      if (!this.form_lark_platform.webhook_url) return

      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/check_lark_webhook', {
          webhook_url: this.form_lark_platform.webhook_url
        }, this.cf())
        this.ntf_s(this.$t('base.connect_config_success'))
        return true
      } catch (e) {
        this.ntf_w(this.$t('base.has_error'))
        return false
      }
    },

    async m__update_lark_webhook() {
      if (!this.form_lark_platform.webhook_url) return
      if (!await this.m__check_lark_webhook()) return

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/open_platform/update_lark_webhook', this.form_lark_platform, this.cf())
        await this.m__get_shopee_shop()
        this.ntf_s(this.$t('base.save_config_success'))
        this.show_dialog.connect_platform = false
      } catch (e) {
        this.ntf_w(this.$t('base.has_error'))
      }
    },

    m__show_upload_file_dialog() {
      this.show_dialog.import_file = true
    },

    m__upload_file() {
      this.$el.querySelector(`#input_control_detail`).click()
    },

    m__import_cookie_file(e) {
      this.import_username = null
      this.import_cookie = null

      this.loading.import_file = true

      const input = e.target

      const reader = new FileReader()
      reader.onload = async () => {
        const text = reader.result

        try {
          const object = JSON.parse(text.trim())
          if (!object || !object.cookies || !object.cookies.length) {
            this.ntf_w(this.$t('base.invalid_file_format'))
            return
          }

          const seller = new SPUserV4()
          seller.username = ''
          seller.password = ''
          seller.cookie = object.cookies.map(i => ({
            name: i.name,
            value: i.value
          }))

          // todo: check seller_api
          const global_found = this.global_shops.find(i => i.country === this.dialog_add_shop.form.country)
          if (global_found) {
            seller.seller_api = global_found.seller_api
            seller.buyer_api = global_found.buyer_api
            seller.account_api = global_found.account_api
          }

          const pre_system_proxy = await this.m__pre_init_system_proxy('test' + new Date().getTime())
          seller.proxy = `system_proxy:${pre_system_proxy}`

          await seller.get_shop_info()
          await seller.get_payment_info()
          await seller.get_partner_login_init()
          const response = await seller.get_shop_info()
          if (response && response.data && response.data.errcode === 0) {
            const json_data = response.data
            const system_proxy = await this.m__init_system_proxy(json_data.shopid, json_data.username)
            const extra = {
              system_proxy,
              user_agent: navigator.userAgent,
              country: this.dialog_add_shop.form.country,
              is_global: true,
              // cookie: seller.cookie
            }
            await this.ADD_SELLER_ACCOUNT(json_data.username, '', json_data.shopid, seller.cookie, this.dialog_add_shop.form.pin_password, extra)
            this.ntf_s(`${this.$t('shop.login_success_account')} ${json_data.username}`)
            this.show_dialog.import_file = false
            await this.m__get_shopee_shop()
          } else {
            this.ntf_w(this.$t('shop.cannot_get_shop_info'))
          }
        } catch (e) {
          this.ntf_w(this.$t('base.invalid_file_format'))
        } finally {
          this.loading.import_file = false
        }
      }
      reader.readAsText(input.files[0])
    },

    async m__setup_shop() {
      this.loading.setup_shop = true
      try {
        const form = {...this.selected_shop}
        if (form.extra_data.use_ip) {
          form.extra_data.use_ip = this.use_ip === 1
        } else {
          Object.assign(form.extra_data, {use_ip: this.use_ip === 1})
        }

        await this.$http.post(this.API.shopee_manager__add_shop, {...form}, this.cf())

        this.ntf_s(this.$t('shop.config_shop_success'))
        this.setup_shop = false
        await this.m__get_shopee_shop()
      } catch (e) {
        this.ntf_e(e)
      } finally {
        this.loading.setup_shop = false
      }
    },

    async m__show_setup_shop(shop) {
      this.use_ip = shop.extra_data.use_ip ? 1 : 0
      this.selected_shop = shop
      this.setup_shop = true
    },

    async m__set_default_for_only() {
      if (this.shopee_shop.list.length === 1) {
        const shop = this.shopee_shop.list[0]
        shop.extra_data.default = true
      }
    },

    async m__get_login() {
      const resp = await this.$http.post('https://api.atosa.asia/api/v1/open-platform/', {
        name: '',
        channel: 'open_platform_shopee',
        redirect_url: `${window.location.origin}/shop`
      }, this.cf())

      if (resp && resp.body && resp.body.data && resp.body.data.url) {
        window.open(resp.body.data.url, '_blank')
      }
    },

    async m__change_default(item, e, ntf = true) {
      if (e) { // e: Boolean
        for (const shop of this.shopee_shop.list) {
          if (item._id !== shop._id && shop.extra_data.default) {
            shop.extra_data.default = false
            await this.UPDATE_SELLER_EXTRA_DATA(shop._id, shop.extra_data)
          }
        }
      }

      await this.UPDATE_SELLER_EXTRA_DATA(item._id, item.extra_data)
      if (e && ntf) this.ntf_s(this.$t('shop.selected_default'))
    },

    async m__get_current_pack() {
      const resp = await this.$http.get(this.API.store_get_current_package, this.cf())
      const marketing_package = resp.body.data.extend_package.find(i => i.channel === 'shopee_marketing')
      if (marketing_package) {
        if (!this.dayjs().isBefore(this.dayjs(new Date(marketing_package.license_to)), 's')) {
          this.ntf_w(this.$t('package.x_has_expired', {x: 'Shopee Marketing'}))
        }
      }
    },

    async m__pre_init_system_proxy(username) {
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/pre_init_system_proxy', {username}, this.cf())
        return response.body.system_proxy
      } catch (e) {
        console.error(`error m__pre_init_system_proxy: ${e}`)
        return ''
      }
    },

    async m__init_system_proxy(shop_id, username) {
      try {
        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/init_system_proxy', {
          shop_id,
          username
        }, this.cf())
        return response.body.system_proxy
      } catch (e) {
        console.error(`error init_system_proxy: ${e}`)
        return ''
      }
    },

    async m__get_shopee_shop() {
      this.shopee_shop.loading = true
      let response = await this.$http.get(this.API.shopee_manager__get_shop + '?channel=shopee_marketing', this.cf())

      // if (this.$store.state.userInfo.username === 'vuducminhdev07') {
      //   response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/get_shop_by_username', {
      //     username: 'bibotest'
      //   }, this.cf())
      // }

      const sync_status_resp = await this.$http.get('https://api.atosa.asia/api/v1/open-platform/sync-status', this.cf())
      const shop_sync = sync_status_resp.body.data

      // const connect_platform_resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/open_platform/get_lark_webhook', this.cf())
      // const connect_platform = connect_platform_resp.body.data

      const sync_data_config_resp = await this.$http.get(this.API.URL_API_SRV_2 + '/mipee/open_platform/sync_data/config', this.cf())
      const sync_data_config = sync_data_config_resp.body.data

      for (const e of response.body.data) {
        e.new_order = 0
        e.new_message = 0
        e.image = ''
        e.user_id = ''
        e.message = '----'
        e.order_meta = {}
        e.loading = false
        e.proxy_ok = false
        e.extra_data.linked = shop_sync.some(i => i.shop_id === e.shop_id)
        e.extra_data.default = !!e.extra_data.default
        e.sync_data = sync_data_config.find(i => i.shop_id === e._id)
      }

      this.shopee_shop.list = response.body.data
      this.shopee_shop.loading = false

      for (const e of this.shopee_shop.list) {
        this.m__proxy_ok(e).catch(console.error)
      }

      this.m_get_shop_image()

      await this.m__set_default_for_only()
    },

    m_delete_shopee_connect(item) {
      this.$confirm(this.$t('shop.confirm_before_delete', {x: item.username}), this.$t('base.attention'),
        {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })
        .then(async () => {
          try {
            this.loading.delete_shop = true

            const data = await this.$http.delete(this.API.shopee_manager__delete_shop.replace('_id', item._id), this.cf())
            this.ntf_s(data)

            this.EB.$emit('shop__change')

            // await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/delete_shop', {shop_id: item._id}, this.cf())
            await this.m__get_shopee_shop()
          } catch (e) {
            this.ntf_w(e)
          } finally {
            this.loading.delete_shop = false
          }
        })
        .catch(console.error)
    },

    m_get_shop_image() {
      this.shopee_shop.list.forEach(async e => {
        if (e.channel === 'shopee_marketing') {
          const seller = await this.init_seller(e, false)

          let json_data = await seller.get_shop_info()
          try {
            const current_info = json_data.data
            e.image = (typeof current_info.portrait !== 'undefined' && current_info.portrait.length > 0)
              ? `https://cf.shopee.vn/file/${current_info.portrait}`
              : ''
            if (current_info.shopid) e.user_id = current_info.shopid
            if (current_info.shopid) e.shop_id = current_info.shopid
            if (current_info.shopid) await seller.get_shop_info()
          } catch (e) {
          }

          const system_proxy = await this.m__init_system_proxy(e.shop_id, e.username)
          await this.UPDATE_SELLER_EXTRA_DATA(e._id, {
            ...e.extra_data,
            system_proxy,
            user_agent: navigator.userAgent
          }, json_data && json_data.data && json_data.data.errcode === 0)
        }
      })
    },

    async m__re_login(shop) {
      if (this.$route.query.cookie) {
        this.shopee_login = true
        this.dialog_add_shop.otp_require = false
        this.dialog_add_shop.form = {
          username: shop.username,
          password: shop.password,
          pin_password: '',
          country: shop.extra_data && shop.extra_data.country ? shop.extra_data.country : 'vn',
        }
      } else {
        const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
        if (!extent_package) {
          this.ntf_w(this.$t('package.x_has_expired', {x: 'Shopee Marketing'}))
          return true
        }

        try {
          shop.loading = true
          const seller = await this.init_seller(shop, false)
          seller.navigator_info = seller.make_navigator_info()
          if (this.dialog_add_shop.form.otp_code) {
            seller.otp_code = this.dialog_add_shop.form.otp_code
          }

          // await seller.get_partner_login_init()
          if (!this.$route.query.cookie) {
            await seller.get_payment_info()
            await seller.get_partner_login_init()
          }
          const json_data = await seller.seller_login(false)
          if (!json_data) {
            this.dialog_add_shop.form.username = shop.username
            this.dialog_add_shop.form.password = ''
            this.shopee_login = true
            this.ntf_w(this.$t('shop.incorrect_account'))
          } else {
            if (json_data.error) {
              if (!json_data.message && json_data.error === 2) {
                json_data.message = 'error_perm'
              }
              if (!json_data.message && json_data.error === 9) {
                json_data.message = 'error_banned'
              }
              if (!json_data.message && json_data.error === 89) {
                json_data.message = 'error_require_captcha'
              }
              if (!json_data.message && json_data.error === 98) {
                json_data.message = 'error_need_ivs'
              }
              if (!json_data.message && json_data.error === 25) {
                json_data.message = 'error_need_ivs'
              }

              switch (json_data.message) {
                case 'error_perm': {
                  this.dialog_add_shop.form.username = shop.username
                  this.dialog_add_shop.form.password = ''
                  this.shopee_login = true
                  this.ntf_w(this.$t('shop.incorrect_account'))
                  break
                }
                case 'error_need_ivs': {
                  let method_type, u_token, ivs_flow_no, fraud_method_resp, fraud_method_found
                  if (json_data && json_data.data && json_data.data.ivs_token) {
                    u_token = json_data.data.ivs_token
                    ivs_flow_no = json_data.data.ivs_flow_no
                    fraud_method_resp = await seller.anti_fraud_ivs_method(u_token)
                    // console.log('fraud_method_resp', fraud_method_resp)
                    if (!fraud_method_resp || !fraud_method_resp.data || !fraud_method_resp.data.length) {
                      this.ntf_w(this.$t('shop.get_method_login_error'))
                      break
                    }

                    fraud_method_found = fraud_method_resp && fraud_method_resp.data && fraud_method_resp.data.length
                      ? fraud_method_resp.data.find(i => [5, 7, 8].includes(i.type))
                      : null
                    method_type = fraud_method_found ? fraud_method_found.type : null
                    if (!method_type) {
                      this.ntf_w(this.$t('shop.method_not_found'))
                      break
                    } else if (method_type === 5) {
                      this.verify_otp_message = this.$t('shop.verify_sms', {x: this.verify_second})
                    } else if (method_type === 8) {
                      this.verify_otp_message = this.$t('shop.verify_email', {x: this.verify_second})
                    } else if (method_type === 7) {
                      this.ntf_w(this.$t('shop.method_not_supported'))
                      break
                    } else {
                      this.verify_otp_message = this.$t('shop.wait_for_logging')
                      this.ntf_w(this.$t('shop.wait_for_logging'))
                    }
                  } else {
                    this.ntf_w(this.$t('shop.method_not_supported'))
                  }

                  this.dialog_add_shop.form.username = shop.username
                  this.dialog_add_shop.form.password = ''
                  this.shopee_login = true
                  this.dialog_add_shop.loading = true
                  this.is_verify_otp = true

                  let verify_token_response
                  if (method_type === 5) {
                    const verify_response = await seller.anti_fraud_verify_sms({
                      msg_type: 1,
                      request_id: u_token,
                      v_token: method_found.v_token,
                      new_sender_meta: {security_device_fingerprint: ''}
                    })
                    // console.log('verify_response 5', verify_response)

                    let stop_waiting_message = false
                    for (let i = 0; i < i + 1 && i < 60 * 5 / 3 && !stop_waiting_message; i++) {
                      const get_status_response = await seller.anti_fraud_get_verify_status({
                        r_token: verify_response.data.r_token
                      })
                      // console.log('get_status_response 5', get_status_response)

                      if (get_status_response && get_status_response.data && get_status_response.data.link_status === 2) {
                        verify_token_response = await seller.anti_fraud_verify_token({
                          event: 1,
                          method_name: method_type,
                          misc: {operation: 0},
                          r_token: verify_response.data.r_token,
                          u_token: u_token,
                          v_token: fraud_method_found.v_token
                        })
                        stop_waiting_message = true
                      }

                      await this.sleep(2000)
                    }
                  } else if (method_type === 8) {
                    const verify_response = await seller.anti_fraud_verify_email({
                      request_id: u_token,
                      v_token: fraud_method_found.v_token,
                      new_sender_meta: {security_device_fingerprint: ''}
                    })
                    // console.log('verify_response 8', verify_response)

                    let stop_waiting_message = false
                    for (let i = 0; i < i + 1 && i < 60 * 5 / 3 && !stop_waiting_message; i++) {
                      const get_status_response = await seller.anti_fraud_get_verify_status({
                        r_token: verify_response.data.r_token
                      })
                      // console.log('get_status_response 8', get_status_response)

                      if (get_status_response && get_status_response.data && get_status_response.data.link_status === 2) {
                        verify_token_response = await seller.anti_fraud_verify_token({
                          event: 1,
                          method_name: method_type,
                          misc: {operation: 0},
                          r_token: verify_response.data.r_token,
                          u_token: u_token,
                          v_token: fraud_method_found.v_token
                        })
                        stop_waiting_message = true
                      }

                      await this.sleep(2000)
                    }
                  } else {
                    this.ntf_w(this.$t('shop.method_not_found'))
                  }

                  // console.log('verify_token_response', verify_token_response)
                  if (verify_token_response && verify_token_response.error === 0) {
                    const login_ivs_response = await seller.anti_fraud_login_ivs({
                      is_user_login: true,
                      is_web: true,
                      ivs_flow_no: ivs_flow_no,
                      ivs_method: method_type,
                      ivs_signature: verify_token_response.signature,
                      device_sz_fingerprint: ''
                    })
                    console.log('login_ivs_response', login_ivs_response)
                    await seller.seller_login(false)
                    const json_data = await seller.seller_get_profile()
                    const extra = {
                      ...shop.extra_data,
                      user_agent: navigator.userAgent,
                      // cookie: seller.cookie
                    }
                    await this.UPDATE_SELLER_ACCOUNT(shop._id, json_data.username, shop.password, json_data.shopid, seller.cookie, this.dialog_add_shop.form.pin_password, extra)
                    this.ntf_s(`${this.$t('shop.login_success_shop')} ${json_data.username}`)
                    this.shopee_login = false
                    await this.m__get_shopee_shop()
                  } else {
                    this.ntf_w(this.$t('shop.cannot_login_shop'))
                  }

                  this.is_verify_otp = false
                  break
                }
                case 'error_banned': {
                  this.ntf_w(this.$t('shop.error_banned'))
                  break
                }
                case 'error_require_captcha': {
                  this.ntf_w(this.$t('shop.error_require_captcha'))
                  break
                }
                case 'error_too_frequent': {
                  this.ntf_w(this.$t('shop.error_require_captcha'))
                  break
                }
                case 'error_captcha': {
                  this.ntf_w(this.$t('shop.error_captcha'))
                  break
                }
                case 'error_notfound': {
                  this.ntf_w(this.$t('shop.error_notfound'))
                  break
                }
                case 'error_need_otp':
                  this.ntf_w(this.$t('shop.error_need_otp'))
                  this.dialog_add_shop.form.username = shop.username
                  this.dialog_add_shop.form.password = shop.password
                  this.shopee_login = true
                  this.dialog_add_shop.otp_require = true
                  break
                default: {
                  this.ntf_w(JSON.stringify(json_data))
                  this.ntf_w(this.$t('shop.cannot_login_shop'))
                  break
                }
              }
            } else if (!json_data.username) {
              this.ntf_w(this.$t('shop.cannot_login_shop'))
            } else {
              try {
                shop.extra_data.system_proxy = await this.m__init_system_proxy(json_data.shopid, json_data.username)
                await this.UPDATE_SELLER_ACCOUNT(shop._id, json_data.username, shop.password, json_data.shopid, seller.cookie, this.dialog_add_shop.form.pin_password, shop.extra_data)
                this.ntf_s(`${this.$t('shop.login_success_shop')} ${json_data.username}`)
              } catch (e) {
                this.ntf_w(e)
              }
              await this.m__get_shopee_shop()
            }
          }
        } catch (e) {
          console.error(e)
          this.ntf_w(this.$t('shop.has_error'))
        } finally {
          shop.loading = false
        }
      }
    },

    async ADD_SELLER_ACCOUNT(username, password, shop_id, cookie, pin_password = '', extra_data = {}, channel = 'shopee_marketing', name = '', device_id = '', token = '') {
      await this.$http.post(this.API.URL_API_SRV_2 + '/shopee/sync', {id: shop_id}, this.cf())

      extra_data = _omit(extra_data, ['wrong_pwd', 'is_needed_otp', 'is_error_api', 'is_banned', 'is_need_ivs', 'too_frequent'])
      return await this.$http.post(this.API.shopee_manager__add_shop, {
        username: username,
        password: password,
        shop_id: shop_id.toString(),
        cookie: cookie,
        device_id: device_id,
        pin_password: pin_password,
        channel: channel,
        name: name,
        token: token,
        extra_data: {...extra_data}
      }, this.cf())
    },

    async UPDATE_SELLER_ACCOUNT(_id, username, password, shop_id, cookie, pin_password = '', extra_data = {}, channel = 'shopee_marketing', name = '', device_id = '', token = '') {
      extra_data = _omit(extra_data, ['wrong_pwd', 'is_needed_otp', 'is_error_api', 'is_banned', 'is_need_ivs', 'too_frequent'])
      return await this.$http.post(this.API.shopee_manager__add_shop, {
        _id: _id,
        username: username,
        password: password,
        shop_id: shop_id.toString(),
        cookie: cookie,
        device_id: device_id,
        pin_password: pin_password,
        channel: channel,
        name: name,
        token: token,
        extra_data: {...extra_data}
      }, this.cf())
    },

    async UPDATE_SELLER_EXTRA_DATA(_id, extra_data, is_omit = false) {
      if (is_omit) {
        extra_data = _omit(extra_data, ['wrong_pwd', 'is_needed_otp', 'is_error_api', 'is_banned', 'is_need_ivs', 'too_frequent'])
      }
      return await this.$http.put(this.API.shopee_manager__add_shop.replace('/shop-manager/shop', `/shop-manager/${_id}/`), {
        extra_data: extra_data
      }, this.cf())
    },

    m__show_login_shopee() {
      this.shopee_login = true
      this.dialog_add_shop.otp_require = false
      this.dialog_add_shop.form = {
        username: this.input_keyword,
        password: '',
        pin_password: '',
        country: 'vn'
      }

      if (this.import_username) this.dialog_add_shop.form.username = this.import_username
      if (this.import_cookie) this.dialog_add_shop.form.cookie = this.import_cookie
    },

    m__convert_cookie_string(cookie) {
      return cookie.split('; ').map(i => {
        const [name, ...value] = i.split('=')
        return {
          name: name,
          value: value.join('=')
        }
      })
    },

    async m__login_shopee_shop() {
      const extent_package = this.$store.state.package.extend_package ? this.$store.state.package.extend_package.find(i => i.channel === 'shopee_marketing') : null
      if (!extent_package) {
        this.ntf_w(this.$t('package.x_has_expired', {x: 'Shopee Marketing'}))
        return true
      }

      if (!this.dialog_add_shop.form.username) {
        this.ntf_w(this.$t('required.username'))
        return
      }

      if (!this.dialog_add_shop.form.password) {
        this.ntf_w(this.$t('required.password'))
        return
      }

      if (this.dialog_add_shop.otp_require && !this.dialog_add_shop.form.otp_code) {
        this.ntf_w(this.$t('shop.error_need_otp'))
        return
      }

      const pre_system_proxy = await this.m__pre_init_system_proxy(this.dialog_add_shop.form.username)

      this.dialog_add_shop.loading = true
      const seller = new SPUserV4()
      seller.username = this.dialog_add_shop.form.username
      seller.password = this.dialog_add_shop.form.password
      seller.proxy = `system_proxy:${pre_system_proxy}`
      seller.navigator_info = seller.make_navigator_info()

      const shop_found = this.shopee_shop.list.find(i => i.username === seller.username)
      if (shop_found) {
        seller.cookie = shop_found.cookie
        seller._id = shop_found._id
        seller.shop_id = shop_found.shop_id
        seller.proxy = `system_proxy:${shop_found.extra_data.system_proxy}`
        seller.navigator_info = shop_found.extra_data.navigator_info || null
        await seller.get_shop_info()
      }

      // todo: check seller_api
      const global_found = this.global_shops.find(i => i.country === this.dialog_add_shop.form.country)
      if (global_found) {
        seller.seller_api = global_found.seller_api
        seller.buyer_api = global_found.buyer_api
        seller.account_api = global_found.account_api
      }

      if (this.dialog_add_shop.form.cookie) {
        seller.cookie = this.m__convert_cookie_string(this.dialog_add_shop.form.cookie)
        await seller.get_shop_info()
      }
      if (this.dialog_add_shop.form.x_sp_dfp) {
        seller.x_sp_dfp = this.dialog_add_shop.form.x_sp_dfp
      }

      if (this.dialog_add_shop.form.otp_code) {
        seller.otp_code = this.dialog_add_shop.form.otp_code
      }

      try {
        if (!this.$route.query.cookie) {
          await seller.get_payment_info()
          await seller.get_partner_login_init()
        }
        const json_data = await seller.seller_login(false)
        if (json_data.error) {
          if (!json_data.message && json_data.error === 2) {
            json_data.message = 'error_perm'
          }
          if (!json_data.message && json_data.error === 9) {
            json_data.message = 'error_banned'
          }
          if (!json_data.message && json_data.error === 89) {
            json_data.message = 'error_require_captcha'
          }
          if (!json_data.message && json_data.error === 98) {
            json_data.message = 'error_need_ivs'
          }
          if (!json_data.message && json_data.error === 25) {
            json_data.message = 'error_need_ivs'
          }

          switch (json_data.message) {
            case 'error_perm': {
              this.ntf_w(this.$t('shop.incorrect_account'))
              break
            }
            case 'error_need_ivs': {
              let method_type, u_token, ivs_flow_no, fraud_method_resp, fraud_method_found
              if (json_data && json_data.data && json_data.data.ivs_token) {
                u_token = json_data.data.ivs_token
                ivs_flow_no = json_data.data.ivs_flow_no
                fraud_method_resp = await seller.anti_fraud_ivs_method(u_token)
                // console.log('fraud_method_resp', fraud_method_resp)
                if (!fraud_method_resp || !fraud_method_resp.data || !fraud_method_resp.data.length) {
                  this.ntf_w(this.$t('shop.get_method_login_error'))
                  break
                }

                fraud_method_found = fraud_method_resp && fraud_method_resp.data && fraud_method_resp.data.length
                  ? fraud_method_resp.data.find(i => [5, 7, 8].includes(i.type))
                  : null
                method_type = fraud_method_found ? fraud_method_found.type : null
                if (!method_type) {
                  this.ntf_w(this.$t('shop.method_not_found'))
                  break
                } else if (method_type === 5) {
                  this.verify_otp_message = this.$t('shop.verify_sms', {x: this.verify_second})
                } else if (method_type === 8) {
                  this.verify_otp_message = this.$t('shop.verify_email', {x: this.verify_second})
                } else if (method_type === 7) {
                  this.ntf_w(this.$t('shop.method_not_supported'))
                  break
                } else {
                  this.verify_otp_message = this.$t('shop.wait_for_logging')
                  this.ntf_w(this.$t('shop.wait_for_logging'))
                }
              } else {
                this.verify_otp_message = this.$t('shop.wait_for_logging')
                this.ntf_w(this.$t('shop.wait_for_logging'))
              }

              this.is_verify_otp = true

              let verify_token_response
              if (method_type === 5) {
                const verify_response = await seller.anti_fraud_verify_sms({
                  msg_type: 1,
                  request_id: u_token,
                  v_token: fraud_method_found.v_token,
                  new_sender_meta: {security_device_fingerprint: ''}
                })
                // console.log('verify_response 5', verify_response)

                let stop_waiting_message = false
                for (let i = 0; i < i + 1 && i < 60 * 5 / 3 && !stop_waiting_message; i++) {
                  const get_status_response = await seller.anti_fraud_get_verify_status({
                    r_token: verify_response.data.r_token
                  })
                  // console.log('get_status_response 5', get_status_response)

                  if (get_status_response && get_status_response.data && get_status_response.data.link_status === 2) {
                    verify_token_response = await seller.anti_fraud_verify_token({
                      event: 1,
                      method_name: method_type,
                      misc: {operation: 0},
                      r_token: verify_response.data.r_token,
                      u_token: u_token,
                      v_token: fraud_method_found.v_token
                    })
                    stop_waiting_message = true
                  }

                  await this.sleep(2000)
                }
              } else if (method_type === 8) {
                const verify_response = await seller.anti_fraud_verify_email({
                  request_id: u_token,
                  v_token: fraud_method_found.v_token,
                  new_sender_meta: {security_device_fingerprint: ''}
                })
                // console.log('verify_response 8', verify_response)

                let stop_waiting_message = false
                for (let i = 0; i < i + 1 && i < 60 * 5 / 3 && !stop_waiting_message; i++) {
                  const get_status_response = await seller.anti_fraud_get_verify_status({
                    r_token: verify_response.data.r_token
                  })
                  // console.log('get_status_response 8', get_status_response)

                  if (get_status_response && get_status_response.data && get_status_response.data.link_status === 2) {
                    verify_token_response = await seller.anti_fraud_verify_token({
                      event: 1,
                      method_name: method_type,
                      misc: {operation: 0},
                      r_token: verify_response.data.r_token,
                      u_token: u_token,
                      v_token: fraud_method_found.v_token
                    })
                    stop_waiting_message = true
                  }

                  await this.sleep(2000)
                }
              } else {
                this.ntf_w(this.$t('shop.method_not_found'))
              }

              // console.log('verify_token_response', verify_token_response)
              if (verify_token_response && verify_token_response.error === 0) {
                const login_ivs_response = await seller.anti_fraud_login_ivs({
                  is_user_login: true,
                  is_web: true,
                  ivs_flow_no: ivs_flow_no,
                  ivs_method: method_type,
                  ivs_signature: verify_token_response.signature,
                  device_sz_fingerprint: ''
                })
                console.log('login_ivs_response', login_ivs_response)
                await seller.seller_login(false)
                const json_data = await seller.seller_get_profile()
                const system_proxy = await this.m__init_system_proxy(json_data.shopid.toString(), json_data.username)
                const extra = {
                  system_proxy: system_proxy || pre_system_proxy,
                  user_agent: navigator.userAgent,
                  country: this.dialog_add_shop.form.country,
                  is_global: true,
                  // cookie: seller.cookie
                }
                await this.ADD_SELLER_ACCOUNT(json_data.username, this.dialog_add_shop.form.password, json_data.shopid, seller.cookie, this.dialog_add_shop.form.pin_password, extra)
                this.ntf_s(`${this.$t('shop.login_success_shop')} ${json_data.username}`)
                this.shopee_login = false
                await this.m__get_shopee_shop()
              } else {
                this.ntf_w(this.$t('shop.cannot_login_shop'))
              }

              this.is_verify_otp = false
              break
            }
            case 'error_banned':
              this.ntf_w(this.$t('shop.error_banned'))
              break
            case 'error_require_captcha': {
              this.ntf_w(this.$t('shop.error_require_captcha'))
              break
            }
            case 'error_too_frequent': {
              this.ntf_w(this.$t('shop.error_require_captcha'))
              break
            }
            case 'error_captcha': {
              this.ntf_w(this.$t('shop.error_captcha'))
              break
            }
            case 'error_notfound': {
              this.ntf_w(this.$t('shop.error_notfound'))
              break
            }
            case 'error_need_otp':
              this.ntf_w(this.$t('shop.error_need_otp'))
              this.dialog_add_shop.otp_require = true
              break
            default: {
              this.ntf_w(JSON.stringify(json_data))
              this.ntf_w(this.$t('shop.cannot_login_shop'))
              break
            }
          }
        } else if (!json_data.username) {
          this.ntf_w(this.$t('shop.cannot_login_shop'))
        } else {
          try {
            const system_proxy = await this.m__init_system_proxy(json_data.shopid, json_data.username)
            const extra = {
              system_proxy: system_proxy,
              country: this.dialog_add_shop.form.country,
              is_global: true
            }
            await this.ADD_SELLER_ACCOUNT(json_data.username, this.dialog_add_shop.form.password, json_data.shopid, seller.cookie, this.dialog_add_shop.form.pin_password, extra)
            this.ntf_s(`${this.$t('shop.login_success_shop')} ${json_data.username}`)
            this.shopee_login = false
          } catch (e) {
            this.ntf_w(e)
          }
          await this.m__get_shopee_shop()
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(e)
      } finally {
        this.dialog_add_shop.loading = false
      }
    },

    m__show_config_proxy(shop) {
      this.selected_shop = shop

      if (shop.extra_data.proxy) {
        Object.assign(this.form_proxy, shop.extra_data.proxy)
      } else {
        this.form_proxy = {
          proxy_type: ['HTTP', 'HTTPS'],
          proxy_server: '',
          proxy_port: null,
          proxy_auth: false,
          proxy_username: '',
          proxy_password: ''
        }
      }

      this.config_proxy = true
    },

    async m__save_config_proxy() {
      if (!this.form_proxy.proxy_type.length) {
        this.ntf_w(this.$t('required.select') + ' Proxy Type')
        return
      }
      if (!this.form_proxy.proxy_server) {
        this.ntf_w(this.$t('required.input') + ' Proxy Server')
        return
      }
      if (!this.form_proxy.proxy_port) {
        this.ntf_w(this.$t('required.input') + ' Proxy Port')
        return
      }
      if (!await this.m__test_proxy()) {
        return
      }

      this.loading.save_config_proxy = true

      try {
        const form = {...this.selected_shop}
        if (form.extra_data.proxy) {
          form.extra_data.proxy = this.form_proxy
        } else {
          Object.assign(form.extra_data, {proxy: this.form_proxy})
        }

        await this.$http.post(this.API.shopee_manager__add_shop, {...form}, this.cf())
        await this.m__get_shopee_shop()
        this.ntf_s(this.$t('base.save_config_success'))
        this.config_proxy = false
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.save_config_proxy = false
      }
    },

    async m__test_proxy() {
      let is_success = false
      this.loading.test_proxy = true

      try {
        await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/test_proxy', {
          schema: 'http',
          dns: this.form_proxy.proxy_server,
          port: this.form_proxy.proxy_port,
          username: this.form_proxy.proxy_auth ? this.form_proxy.proxy_username : '',
          password: this.form_proxy.proxy_auth ? this.form_proxy.proxy_password : ''
        })
        this.ntf_s(this.$t('shop.connect_proxy_success'))
        is_success = true
      } catch (e) {
        this.ntf_w(this.$t('shop.invalid_proxy'))
      } finally {
        this.loading.test_proxy = false
      }

      return is_success
    },

    async m__proxy_ok(shop) {
      if (shop.extra_data && shop.extra_data.proxy) {
        try {
          await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/test_proxy', {
            schema: 'http',
            dns: shop.extra_data.proxy.proxy_server,
            port: shop.extra_data.proxy.proxy_port,
            username: shop.extra_data.proxy.proxy_auth ? shop.extra_data.proxy.proxy_username : '',
            password: shop.extra_data.proxy.proxy_auth ? shop.extra_data.proxy.proxy_password : ''
          })
          shop.proxy_ok = true
          return true
        } catch (e) {
          shop.proxy_ok = false
          return false
        }
      }

      return false
    },

    async m__delete_proxy() {
      try {
        await this.$confirm(this.$t('base.confirm_delete_x', {x: 'proxy'}), this.$t('base.attention'),
          {
            type: 'warning',
            confirmButtonText: this.$t('base.confirm'),
            cancelButtonText: this.$t('base.cancel')
          })
        const form = {...this.selected_shop}
        form.extra_data = _omit(form.extra_data, 'proxy')

        await this.$http.post(this.API.shopee_manager__add_shop, {...form}, this.cf())
        this.ntf_s(this.$t('base.delete_x_success', {x: 'proxy'}))
        this.config_proxy = false
        this.selected_shop.extra_data = _omit(this.selected_shop.extra_data, 'proxy')
      } catch (e) {
      }
    }
  }
}
</script>

<style lang="scss">
.shopee__shop-item {

  .shop__shop-item__image {
    float: left;
    width: 50px;
    height: 50px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.btn--change-shop-logo {
  background-color: whitesmoke;
  color: black;
  font-weight: bolder;
  border: 0;
  border-radius: 5px;
  padding: 3px;
  width: 30px;
}

#shop-table {
  th, td {
    padding-left: 0 !important;
  }

  #main-tr {
    td {
      padding-top: 6px !important;
      padding-bottom: 6px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/shop/index.vue